
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";

interface VideoSectionProps {
  title: string;
  description: string;
  videoId?: string;
  placeholder?: string;
}

const VideoSection: React.FC<VideoSectionProps> = ({ 
  title, 
  description, 
  videoId, 
  placeholder = "/placeholder.svg" 
}) => {
  return (
    <section className="py-16 px-6 bg-white">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4">{title}</h2>
            <p className="text-lg text-gray-700 mb-6">{description}</p>
          </div>
          
          <Card className="overflow-hidden border-none shadow-lg">
            <CardContent className="p-0">
              {videoId ? (
                <div className="aspect-video">
                  <iframe 
                    className="w-full h-full"
                    src={`https://www.youtube.com/embed/${videoId}`}
                    title="YouTube video"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              ) : (
                <div className="aspect-video bg-gray-100 flex items-center justify-center">
                  <div className="text-center p-6">
                    <div className="w-16 h-16 bg-noordblue-light rounded-full flex items-center justify-center mx-auto mb-3">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-noordblue">
                        <polygon points="5 3 19 12 5 21 5 3"></polygon>
                      </svg>
                    </div>
                    <p className="text-gray-500">Hier komt ooit een video</p>
                  </div>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default VideoSection;
